import React from "react";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../../components/UI/Wrapper";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import LeadDataOps from "../../../components/DashboardComponentsOps/LeadDataOps/LeadDataOps";
import CityGraph from "../../../components/DashboardComponentsOps/CityGraph/CityGraph";
import Countrygraph from "../../../components/DashboardComponentsOps/Countrygraph/Countrygraph";
import "./DashboardOps.css";
import JobTypeGraph from "../../../components/DashboardComponentsOps/JobTypeGraph/JobTypeGraph";
import OrderStage from "../../../components/DashboardComponentsOps/OrderStage/OrderStage";
import OrderStatus from "../../../components/DashboardComponentsOps/OrderStatus/OrderStatus";
import DashboardTable from "../../../components/DashboardComponentsOps/dashboardTable/dashboardTable";

const DashboardOps = () => {

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid wholeContainer"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            ></div>

            <div>
              <div className="datattat" style={{ width: "100%" }}>
                <LeadDataOps />
              </div>
              {/* ------------------ Job Type ------------------------------ */}
              {/* <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "30px",
                  paddingBottom: "30px",
                }}
              >
                <Wrapper>
                  <JobTypeGraph />
                </Wrapper>

              </div> */}
              <div style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                paddingTop: "30px",
                paddingBottom: "30px",
               
                
              }}>
                <Wrapper>
                  <DashboardTable />
                </Wrapper>
              </div>
            </div>
          </div>
          <Wrapper>
            <div style={{ display: "flex" }}>
              <Countrygraph />
              <CityGraph />
            </div>
          </Wrapper>

          <div style={{ display: "flex", marginTop: "2rem" }}>
            {/* ----------------- Order Stage ---------------------- */}
            <div className="container" style={{ width: "50%" }}>
              <Wrapper className="orderStagePieChart">
                <OrderStage />
              </Wrapper>
            </div>

            {/* --------------- Order Status --------------------- */}
            <div className="container" style={{ width: "50%" }}>
              <Wrapper
                className="colorLeadStage"
                style={{ width: "100%", backgroundColor: "white" }}
              >
                <OrderStatus />
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardOps;
